module.exports =  {
    ROLE_ADMIN: 1,
    ROLE_REGIONAL_FEDERATION: 2,
    ROLE_CLUB: 3,
    ROLE_ATHLETE: 4,
    ROLE_CREDENTIAL_COMMISSION: 5
};
